import { deviceTypeOptions } from "@/utils/enums";

export const shopType = deviceTypeOptions;
